// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-1-FjF";
var _4 = "loyalty__link-FRnNe";
var _5 = "seatNumber-1-u15";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "loyalty__link", _5 as "seatNumber" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "loyalty__link": _4, "seatNumber": _5 }
